/**
 * 蓝图原片直链(BPWB-1,2026-09-03)—— 蓝图工作卡(BlueprintHeroCard)在各目的地
 * 创建页播原片用。与 features/explosive/api/explosiveService.ts `getRawVideoUrl`
 * 同一个后端口(那份是追爆舱详情抽屉在用;本层不能反向 import features,故各自一行)。
 *
 * ★**点击才调**,不随进页预取:签名 30 分钟 TTL,提前签好躺在页面上等于开着一个
 *   会过期的空头支票(0901 海报线 firstFrameUrl 同坑)。
 * ★拿到的 URL **只许进 `<video src>`,不许 fetch**(CSP `connect-src 'self'`)。
 * 蓝图没留原片 → 后端 404 带人话,由调用方直接展示。
 */
import { api } from "@/shared/api";

export const blueprintMediaService = {
  getRawVideoUrl: (id: number) =>
    api.get<{ url: string }>(`/explosive/blueprints/${id}/raw-video-url`),
};
